<script>
import Favourite from '~/static/images/favourite.svg';
import FavouriteFilled from '~/static/images/favourite-filled.svg';

export default {
    name: 'ToggleFavourite',
    components: {
        Favourite,
        FavouriteFilled,
    },
    props: {
        productId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        isFavourite() {
            return this.$store.getters['user/hasFavourite'](this.productId);
        },
    },
    methods: {
        async toggleFavourite() {
            if (this.$store.getters['user/isLoggedIn']) {
                await this.$store.dispatch('user/toggleFavourite', this.productId);
                return;
            }

            await this.$store.dispatch('user/setPendingFavourite', this.productId);
            this.$modal.show('auth-modal');
        },
    },
};
</script>

<template>
    <div class="rounded-full">
        <button
            class="w-full h-full"
            @click.prevent="toggleFavourite"
        >
            <FavouriteFilled
                v-if="isFavourite"
                class="w-full h-full"
            />
            <Favourite
                v-else
                class="w-full h-full"
            />
            <span class="sr-only">
                {{ isFavourite ? 'Remove from favourites' : 'Add to favourites' }}
            </span>
        </button>

    </div>
</template>

<style scoped lang="scss">

</style>
